module.exports = {
    minPasswordLength: 8,
    maxPasswordLength: 20,

    checkPassword: function (password, password_confirmation) {
        var errorIllegal = "Password should be at least "
                            + this.minPasswordLength + "-" + this.maxPasswordLength
                            + " characters long, contain 1 Uppercase letter, 1 lowercase letter,  1 number and special character";

        var regex = /^(?=.*\d)(?=.*?[#?!@$%^&*-/{/}/)/(\[\]])(?=.*[a-z])(?=.*[A-Z]).{8,20}$/;

        if (!regex.test(password)) {
            return { valid: false, error: errorIllegal };
        }

        if (String(password) !== String(password_confirmation)) {
            return {
                valid: false,
                error: "Password and Confirm password don't match",
            };
        }

        return { valid: true, error: "" };
    },
    checkEmail: function (email) {
        //simplest form of email validation: http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    },
    checkUrl: function (url) {
        //simplest form of url validation
        var re = /^http[s]?:\/\/\S+\.\S+/;
        return re.test(url);
    },
    checkInstanceEmailRegex: function (email, regex) {
        var re = new RegExp(regex);
        return re.test(email);
    },
};



// WEBPACK FOOTER //
// ./auth/classes/signUpFormValidations.js